import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';
import {OrangeTextButton} from "../../../gpap-lib/Button_Collection";
import BlackButton from "../components/BlackButton.js"
import { grey } from '@mui/material/colors';


const menuItemSx = {
    color: grey[900], 
    backgroundColor: grey[50],
    '&:hover': {
      color: 'primary.main',
      backgroundColor: grey[200],
    },
} 

export default function NavigationMenu(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            {
                (props.orange) ?
                    <OrangeTextButton className={{a: {color: "orange"}}}  onClick={handleClick} >{props.title}</OrangeTextButton>
                :
                    <BlackButton aria-controls="data_submission"  aria-haspopup="true" onClick={handleClick} sx={{ color: 'text.primary' }}>{props.title}</BlackButton>
            }
            <Menu
                id="data_submission"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
            { 
                props.items.map(item => { 
                    return <Link to={item.to} style={{ textDecoration: 'none' }}>
                               <MenuItem
                                   onClick={() => handleClose()} sx={menuItemSx}> {item.label} </MenuItem>
                           </Link>
                })  
            }
            </Menu>
        </React.Fragment>
    );
}